import React, { Component } from 'react';
import * as firebase from "firebase/app";
import { configureInstagram, getPagesFacebook, getPageInstagram } from '../../../services/MetaService';
import { ValidatorForm, SelectValidator, TextValidator } from 'react-material-ui-form-validator';
import MenuItem from "@material-ui/core/MenuItem";
import { firestore } from '../../../firebase-config';
import { base_url, api_key } from '../../../config/config_api';

// Página + conta Instagram vinculada numa única chamada (requer pages_show_list + instagram_basic).
const CAMPOS_PAGINAS = 'id,name,instagram_business_account';

const MSG_SEM_PAGINAS = 'Nenhuma Página do Facebook foi autorizada. Feche esta janela, clique novamente em "Autorizar acesso Instagram" e, na janela do Facebook, marque a Página vinculada à conta do Instagram (passo "Escolher Páginas"). Se a Página for gerenciada por um Portfólio Empresarial (Business Manager), confirme que sua conta tem acesso total a ela. Você também pode informar o ID da conta do Instagram manualmente.';

const MSG_AUTORIZACAO_NAO_CONCLUIDA = 'A autorização no Facebook não foi concluída. Feche esta janela e clique novamente em "Autorizar acesso Instagram".';

const descreverErroMeta = (erro) => {
    if (erro && typeof erro === 'object' && erro.message) {
        return erro.message + (erro.code !== undefined ? ' (código ' + erro.code + ')' : '');
    }
    return typeof erro === 'string' ? erro : '';
};

class RevendaIntegracaoConfigurarInstagram extends Component {

    constructor (props){
        super(props);

        this.state = {
            idRevenda: "",
            status: 0,
            existeConfiguracao: false,
            dataAtual: null,
            paginas: [],
            isLoading: true,
            estaGravando: false,
            pagina: "",
            facebook_id: "",
            facebook_token: "",
            instagram_dados: "",
            instagram_selecionado: false,
            instagram_id: "",
            instagram_name: "",
            instagram_manual: false,
            id_conta_instagram: "",
            mensagem_erro: "",
            aviso: "",
            autorizacao_falhou: false
        }
        this.mounted = false;
        this.handleChange  = this.handleChange.bind(this);
        this.handleSubmit  = this.handleSubmit.bind(this);
    }

    componentDidMount(){

        this.state.dataAtual = firebase.firestore.FieldValue.serverTimestamp();

        // Sucesso: token no hash (#access_token=...&state=...).
        // Recusa/cancelamento: erro na query (?error=access_denied&error_description=...).
        const token_data = {};
        new URLSearchParams(window.location.hash.substring(1)).forEach((value, key) => {
            token_data[key] = value;
        });

        if(!token_data.state || !token_data.access_token){
            const erroRetorno = new URLSearchParams(window.location.search);
            console.error("Autorização Meta não concluída:", {
                error: erroRetorno.get("error"),
                error_reason: erroRetorno.get("error_reason"),
                error_description: erroRetorno.get("error_description")
            });
            this.setState({
                isLoading: false,
                autorizacao_falhou: true,
                aviso: MSG_AUTORIZACAO_NAO_CONCLUIDA
            });
            return;
        }

        token_data.status = parseInt(this.state.status) === 1 ? true : false;
        token_data.existeConfiguracao = this.state.existeConfiguracao;
        token_data.dataAtual = this.state.dataAtual;
        token_data.idRevenda = token_data.state;

        this.setState({ idRevenda: token_data.state });

        this.configureInstagram(token_data.idRevenda, token_data);

    }

    configureInstagram = async (idRevenda, token_data) => {
        const response = await configureInstagram(idRevenda, token_data);

        if(response.status !== "success" || !response.data || !response.data.long_lived_token){
            console.error("Erro ao configurar integração Instagram:", response.data);
            const detalhe = typeof response.data === 'string' ? response.data + ' ' : '';
            this.setState({
                isLoading: false,
                autorizacao_falhou: true,
                aviso: 'Não foi possível concluir a autorização do Instagram. ' + detalhe + 'Feche esta janela e tente novamente.'
            });
            return;
        }

        const facebook_id    = response.data.user_id;
        const facebook_token = response.data.long_lived_token;

        this.setState({ facebook_id, facebook_token });

        const response2 = await getPagesFacebook(facebook_id, facebook_token, CAMPOS_PAGINAS);

        if(response2.status !== "success"){
            console.error("Erro da Meta ao listar Páginas autorizadas:", response2.data);
            const detalhe = descreverErroMeta(response2.data);
            this.setState({
                isLoading: false,
                instagram_manual: true,
                instagram_selecionado: true,
                aviso: 'Não foi possível carregar as Páginas autorizadas' + (detalhe ? ' (' + detalhe + ')' : '') + '. Informe o ID da conta do Instagram manualmente ou feche esta janela e autorize novamente.'
            });
            return;
        }

        const paginas = response2.data;
        if(paginas.length === 0){
            console.warn("Meta retornou /accounts vazio: nenhuma Página concedida na autorização.");
        }

        this.setState({
            isLoading: false,
            paginas,
            instagram_manual: paginas.length === 0,
            instagram_selecionado: paginas.length === 0,
            aviso: paginas.length === 0 ? MSG_SEM_PAGINAS : ""
        });

    }

    async handleChange(event) {

        const target = event.target;
        const value  = target.value;
        const name   = target.name;

        this.setState({
            [name]: value,
        });

        if(name === 'pagina'){

            this.setState({
                instagram_manual: false,
                instagram_id: "",
                instagram_name: "",
                instagram_dados: "",
                instagram_selecionado: false,
                aviso: ""
            });

            const paginaSelecionada = this.state.paginas[value];
            if(paginaSelecionada === undefined){
                return;
            }

            const instagramId = paginaSelecionada.instagram_business_account
                ? paginaSelecionada.instagram_business_account.id
                : undefined;

            if(!instagramId){
                this.setState({
                    instagram_manual: true,
                    instagram_selecionado: true,
                    aviso: 'A Página "' + paginaSelecionada.name + '" não tem conta profissional do Instagram vinculada. Vincule a conta à Página (Instagram ou Meta Business Suite) e autorize novamente, ou informe o ID da conta manualmente.'
                });
                return;
            }

            // Nome é só para exibição; o vínculo já veio de /accounts e o backend revalida ao gravar.
            const response = await getPageInstagram(instagramId, this.state.facebook_token);
            if(this.state.pagina !== value){
                return; // usuário trocou de Página durante a consulta
            }
            if(response.status !== "success"){
                console.error("Erro da Meta ao consultar conta Instagram:", response.data);
            }
            const nomeInstagram = response.status === "success" ? response.data.name : "";
            this.setState({
                instagram_id: instagramId,
                instagram_name: nomeInstagram,
                instagram_dados: nomeInstagram ? nomeInstagram + " - " + instagramId : instagramId,
                instagram_selecionado: true
            });
        }
    }

    async handleSubmit(event) {

        event.preventDefault();
        
        var validaConfiguracao = false;

        this.setState({
            mensagem_erro: ""
        });

        if(this.state.instagram_manual && this.state.id_conta_instagram !== ""){

            const response = await getPageInstagram(this.state.id_conta_instagram, this.state.facebook_token);
            if(response.status === "success"){
                this.setState({
                    instagram_id: response.data.id,
                    instagram_name: response.data.name,
                    instagram_dados: response.data.name + " - " + response.data.id,
                    instagram_selecionado: true
                });
                validaConfiguracao = true;
            }else{
                this.setState({
                    instagram_id: "",
                    instagram_name: "",
                    instagram_dados: "",
                    mensagem_erro: "Conta do Instagram não encontrada ou acesso não permitido, utilize um ID válido."
                });
            }
        }else{
            if(this.state.instagram_id !== ""){
                validaConfiguracao = true;
            }
        }

        if(validaConfiguracao){

            this.setState({estaGravando: true});

            var user = JSON.parse(window.localStorage.getItem("usuarioLogado"));
            var integracao = {
                page_id: this.state.instagram_id,
                page_name: this.state.instagram_name,
                updated_id: user.id,
                updated_at: this.state.dataAtual,
                status: true
            }

            firestore.collection("revenda").doc(this.state.idRevenda).collection("integracoes").doc("instagram").set(integracao, { merge: true })
            .then(res => { 

                fetch(base_url+"/api/integracao/instagram/configurar-pagina", { 
                    method: "POST", 
                    headers: { 
                        'Content-Type': 'application/json',
                    }, 
                    body: JSON.stringify({
                        "api_key": api_key,
                        "id_revenda": this.state.idRevenda,
                        "page_id": this.state.instagram_id,
                        "page_name": this.state.instagram_name,
                        "page_access_token": this.state.facebook_token,
                        "usuario": user.id,
                    })
                })
                .then(response => {
        
                    response.json()
                    .then(data => {
                        this.setState({estaGravando: false});
                        if(data.status !== 'success'){
                            firestore.collection("revenda").doc(this.state.idRevenda).collection("integracoes").doc("instagram").set({ status: false }, { merge: true });
                            alert(data.data || "Erro ao configurar integração com Instagram.");
                            window.close();
                            return;
                        }
                        const resposta4 = window.confirm('Instagram configurado com sucesso!');
                        if (resposta4) {
                            window.close();
                        } else {
                            window.close();
                        }
                    });

                    this.setState({estaGravando: false});  
        
                })
                .catch(error => {
                    this.setState({estaGravando: false});  
                    console.error("Erro get teste", error);
                });

            })
            .catch(err => { 
                firestore.collection("revenda").doc(this.state.idRevenda).collection("integracoes").doc("instagram").set({ status: false }, { merge: true });
                alert("Erro ao configurar integração.")
                this.setState({estaGravando: false});     
            });

        }        

    }

    render(){    
        const { 
            isLoading, 
            paginas,
            estaGravando,
            pagina,
            instagram_dados,
            instagram_selecionado,
            instagram_manual,
            id_conta_instagram,
            mensagem_erro,
            aviso,
            autorizacao_falhou
        } = this.state;

        return (
            <div className="mt-5">
                { 
                    isLoading ? 

                    <div className="progress progress-upload-images progress-upload-images-integracao">
                        <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style={{ width: "100%" }}>Aguarde...</div>
                    </div>

                    : 
                
                    <div id="page-wrapper">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="panel panel-default">
                                    <div className="panel-heading">
                                        Selecionar página do Facebook
                                    </div>
                                    <div className="panel-body">

                                        {
                                            aviso !== "" ?
                                            (
                                                <div className={ autorizacao_falhou ? "alert alert-danger" : "alert alert-warning" } role="alert">{ aviso }</div>
                                            ) : ""
                                        }

                                        { !autorizacao_falhou && (
                                        <ValidatorForm
                                            ref="form"
                                            onSubmit={this.handleSubmit}
                                        >

                                            { 
                                                paginas.length > 0 &&
                                                (
                                                    <div className="row">
                                                        <div className="col-lg-4">
                                                            <div className="form-group">
                                                                <SelectValidator
                                                                    label="Página Facebook"
                                                                    value={ pagina }
                                                                    name="pagina"
                                                                    className="form-ui-bootstrap"
                                                                    onChange={this.handleChange}
                                                                    validators={["required"]}
                                                                    errorMessages={["Preenchimento obrigatório"]}
                                                                    >
                                                                        <MenuItem value="" ></MenuItem>

                                                                        {
                                                                        paginas.map((element, id) =>
                                                                            <MenuItem value={id} key={id}>{element.name + (element.instagram_business_account ? "" : " (sem Instagram vinculado)")}</MenuItem>
                                                                        )
                                                                    }
                                                                </SelectValidator>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }

                                            {
                                                instagram_manual ?
                                                (
                                                    <div className="row">
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                                <TextValidator
                                                                    label="ID Conta Instagram"
                                                                    onChange={this.handleChange}
                                                                    name="id_conta_instagram"
                                                                    value={id_conta_instagram}
                                                                    className="form-ui-bootstrap"
                                                                    validators={['required']}
                                                                    errorMessages={['Preenchimento obrigatório']}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : ""
                                            }

                                            {
                                                instagram_dados !== "" ?
                                                 (
                                                    <div className="row">
                                                        <div className="col-lg-12">
                                                            <h4>Conta Instagram selecionada</h4>
                                                            <p>{ instagram_dados }</p>
                                                        </div>
                                                    </div>
                                                 ) : ""
                                            }

                                            {
                                                mensagem_erro !== "" ?
                                                (
                                                    <div className="row">
                                                        <div className="col-lg-12">
                                                            <p className="error">{ mensagem_erro }</p>
                                                        </div>
                                                    </div>
                                                 ) : ""
                                            }
                                            
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <button type="submit" className="btn btn-primary" disabled={estaGravando || !instagram_selecionado} >Gravar</button>
                                                </div>
                                            </div>
                                        </ValidatorForm>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    }

}

export default RevendaIntegracaoConfigurarInstagram
